import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SharedHttp } from '../../services/http-client.service';
import { ComponentService } from '../../services/component.service';
import { UtilityService } from '../../services/utility.service';
import { AuthService } from '../../services/auth.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from "@angular/platform-browser";
import { CountdownTimerComponent } from './../countdown-timer';
import { SmsConfirmationComponent } from '../sms-confirmation-component';
import { AllowModalComponent } from './../allow-modal';
/**
 * Confirm Component
 */
let EcdConfirmComponent = class EcdConfirmComponent {
    constructor(httpClient, router, compService, convertor, auth, webSettingsService, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.router = router;
        this.compService = compService;
        this.convertor = convertor;
        this.auth = auth;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.confirmData = {};
        this.dataObject = {};
        this.userData = {};
        this.successColor = '';
        this.mainColor = '';
        this.linkColor = '';
        this.errorMessage = '';
        this.tokenError = false;
        this.smsError = false;
        this.paymentCanExpire = false;
        this.isL2LimitOrder = false;
        this.isPaymentExpirationTerminal = false;
        this.timeIsUp = false;
        this.submitErrorMessage = '';
        this.workingOnTransaction = false;
        this.clicked = false;
        this.errorInForm = false;
        this.borderRadiusLarger = '';
        this.confirmedCardTransaction = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        if (typeof this.isGuest !== 'undefined' && this.isGuest) {
            this.userType = 'guest';
            if (typeof this.orderId !== 'undefined') {
                this.getOrderDataGuest(this.orderId + '');
            }
            this.webSettingsService.getSettings().subscribe(data => {
                if (!this.webSettingsService.applySettings('GUEST_USER.ON')) {
                    this.router.navigate(['/']);
                }
            });
        }
        else {
            this.userData = JSON.parse(localStorage.getItem('user'));
            this.userType = this.userData.user_type_id.type;
            this.isIndividual = this.userData.is_company_user ? 0 : 1;
            if (typeof this.orderId !== 'undefined') {
                this.getOrderData(this.orderId + '');
            }
        }
    }
    getOrderDataGuest(oid) {
        if (oid !== '') {
            this.httpClient.get('market/order/guest/' + oid).subscribe((data) => {
                this.confirmData = data;
                this.paymentCanExpire = this.confirmData.payment_can_expire;
                this.isL2LimitOrder = this.confirmData.status == "Dokumentacija odobrena";
                this.isPaymentExpirationTerminal = this.confirmData.is_payment_expiration_terminal;
                this.meanOfPayment = this.confirmData.mean_of_payment.verbose_id;
                this.nameOfCurrency = this.confirmData.cryptocurrency;
                this.expiresAtUTC = this.confirmData.payment_expires_timestamp;
                const currentTime = new Date().getTime();
                const transactionTime = this.expiresAtUTC - this.confirmData.created_at_timestamp;
                this.blinkTime = Math.round(parseInt(transactionTime + "") / 3);
                if (this.paymentCanExpire) {
                    this.timer.initialise(this.isPaymentExpirationTerminal, this.blinkTime, this.expiresAtUTC);
                }
                this.convertor.convertToShortcut(this.nameOfCurrency).then(result => {
                    this.currency = result + '';
                    this.httpClient.get('market/feesandlimits?ecurrency=' + this.currency + '&mop=' + this.meanOfPayment + '&user_type=' + this.userType + '&order_type=' + this.orderType + '&is_individual=' + this.isIndividual).subscribe((data) => {
                        this.provision = data[this.orderType][this.currency][this.meanOfPayment][this.userType].fee;
                    });
                });
            });
        }
    }
    getOrderData(oid) {
        if (oid !== '') {
            this.httpClient.get('market/user/orders/' + oid).subscribe((data) => {
                this.confirmData = data;
                if (!('bank_payment_details' in this.confirmData)) {
                    this.confirmData.bank_payment_details = null;
                }
                this.paymentCanExpire = this.confirmData.payment_can_expire;
                this.isL2LimitOrder = this.confirmData.status == "Dokumentacija odobrena";
                this.isPaymentExpirationTerminal = this.confirmData.is_payment_expiration_terminal;
                this.meanOfPayment = this.confirmData.mean_of_payment.verbose_id;
                this.nameOfCurrency = this.confirmData.cryptocurrency;
                this.convertor.convertToShortcut(this.nameOfCurrency).then(result => {
                    this.currency = result + '';
                    this.httpClient.get('market/feesandlimits?ecurrency=' + this.currency + '&mop=' + this.meanOfPayment + '&user_type=' + this.userType + '&order_type=' + this.orderType + '&is_individual=' + this.isIndividual + '&chain=' + this.confirmData.ecurrency_chain['chain']['name']).subscribe((data) => {
                        this.provision = data[this.orderType][this.currency][this.meanOfPayment][this.userType].fee;
                    });
                });
                this.expiresAtUTC = this.confirmData.payment_expires_timestamp;
                const currentTime = new Date().getTime();
                const transactionTime = this.expiresAtUTC - this.confirmData.created_at_timestamp;
                this.blinkTime = Math.round(parseInt(transactionTime + "") / 3);
                if (this.paymentCanExpire) {
                    this.timer.initialise(this.isPaymentExpirationTerminal, this.blinkTime, this.expiresAtUTC);
                }
            });
        }
    }
    goBack() {
        this.router.navigateByUrl('/tx');
        if (typeof this.isGuest !== 'undefined' && this.isGuest) {
            this.router.navigateByUrl('/tx');
        }
        else if (typeof this.isGuest !== 'undefined' && !this.isGuest) {
            if (typeof this.orderType !== 'undefined' && this.orderType === 'buy') {
                this.router.navigateByUrl('/buy/' + this.currency + '/' + this.meanOfPayment + '/buy');
            }
            else if (typeof this.orderType !== 'undefined' && this.orderType === 'sell') {
                this.router.navigateByUrl('/sell/' + this.currency + '/sell');
            }
        }
    }
    submit() {
        this.errorMessage = '';
        let clientID;
        if (typeof this.smsComponent !== 'undefined' && typeof this.isGuest !== 'undefined' && this.isGuest) {
            this.errorInForm = !this.smsComponent.checkToken();
            if (this.smsComponent.checkToken()) {
                this.dataObject.token = this.smsComponent.dataObject.token;
                this.dataObject.order_id = this.orderId;
                if (window.ga !== undefined) {
                    clientID = this.getClientId();
                }
                else {
                    clientID = null;
                }
                this.dataObject.ga_client_id = clientID;
                this.httpClient.post('market/order/guest/save', this.dataObject).subscribe(order => {
                    if (this.valid) {
                        this.router.navigateByUrl('/tx/end/' + this.orderId);
                    }
                    this.confirmedCardTransaction.emit(false);
                }, error => {
                    this.errorMessage = error.error['message'];
                    this.acceptTermsAndConditions = false;
                    this.acceptOwnNameAndAccount = false;
                    this.smsError = true;
                    this.workingOnTransaction = false;
                    if (this.errorMessage === 'ORDER_TIME_UP' || this.errorMessage === 'PAYMENT_TIME_EXPIRED') {
                        this.timeIsUp = true;
                        this.router.navigateByUrl('/tx/end/transaction_timeup/' + this.orderId);
                    }
                    this.confirmedCardTransaction.emit(false);
                });
            }
        }
        else if (typeof this.isGuest !== 'undefined' && !this.isGuest) {
            if (typeof this.orderType !== 'undefined') {
                this.workingOnTransaction = true;
                this.dataObject.order_id = this.orderId;
                if (window.ga !== undefined) {
                    clientID = this.getClientId();
                }
                else {
                    clientID = null;
                }
                this.dataObject.ga_client_id = clientID;
                this.httpClient.post('market/order/save/order', this.dataObject).subscribe((order) => {
                    if (this.userData.validation_required === 1) {
                        this.compService.openModal(AllowModalComponent, {
                            order_id: this.orderId
                        }, (success) => {
                            this.router.navigateByUrl('');
                        });
                    }
                    else {
                        if (this.meanOfPayment === 'bank_slip') {
                            this.router.navigateByUrl('/' + this.orderType + '/end/' + this.orderId);
                        }
                    }
                    if (this.meanOfPayment === 'bank_slip') {
                        this.router.navigateByUrl('/' + this.orderType + '/end/' + this.orderId);
                        this.confirmedCardTransaction.emit(false);
                    }
                    else if (this.meanOfPayment === 'card') {
                        this.confirmedCardTransaction.emit(true);
                    }
                }, (error) => {
                    this.workingOnTransaction = false;
                    this.submitErrorMessage = error.error['error_message'];
                    if (this.submitErrorMessage === 'ORDER_TIME_UP' || this.submitErrorMessage === 'PAYMENT_TIME_EXPIRED') {
                        this.timeIsUp = true;
                        this.router.navigateByUrl('/' + this.orderType + '/end/' + 'transaction_timeup/' + this.orderId);
                    }
                    this.confirmedCardTransaction.emit(false);
                });
            }
        }
    }
    getClientId() {
        try {
            return window.ga.getAll()[0].get('clientId');
        }
        catch (e) {
            return null;
        }
    }
    checkedBox(e) {
        if (this.acceptTermsAndConditions && this.acceptOwnNameAndAccount) {
            if (this.isGuest) {
                this.errorInForm = this.smsComponent.checkToken();
                this.smsError = this.smsComponent.checkToken();
            }
            this.valid = true;
        }
        else {
            this.valid = false;
        }
    }
    expired(isExpired) {
        if (isExpired) {
            this.timeIsUp = true;
            if (typeof this.isGuest !== 'undefined' && this.isGuest) {
                this.router.navigateByUrl('/tx/end/transaction_timeup/' + this.orderId);
            }
            else if (typeof this.isGuest !== 'undefined' && !this.isGuest) {
                if (typeof this.orderType !== 'undefined') {
                    this.router.navigateByUrl('/' + this.orderType + '/end/' + 'transaction_timeup/' + this.orderId);
                }
            }
        }
    }
    checkToken() {
        this.errorInForm = this.smsComponent.checkToken();
        return this.errorInForm;
    }
};
EcdConfirmComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: ComponentService },
    { type: UtilityService },
    { type: AuthService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
__decorate([
    ViewChild(CountdownTimerComponent)
], EcdConfirmComponent.prototype, "timer", void 0);
__decorate([
    ViewChild(SmsConfirmationComponent)
], EcdConfirmComponent.prototype, "smsComponent", void 0);
__decorate([
    Input()
], EcdConfirmComponent.prototype, "orderId", void 0);
__decorate([
    Input()
], EcdConfirmComponent.prototype, "orderType", void 0);
__decorate([
    Input()
], EcdConfirmComponent.prototype, "isGuest", void 0);
__decorate([
    Output()
], EcdConfirmComponent.prototype, "confirmedCardTransaction", void 0);
EcdConfirmComponent = __decorate([
    Component({
        selector: 'ecd-confirm-component',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./confirm.component.html")).default
    })
], EcdConfirmComponent);
export { EcdConfirmComponent };
